<template>
    <div>
        <UPopover
            :mode="forceOpen ? 'click' : 'hover'"
            v-model:open="open"
            :popper="{ placement: 'bottom-start' }"
            :close-delay="500"
            :disabled="cartCount === 0"
        >
            <UChip color="rose" size="lg" :show="cartCount > 0" :text="cartCount" :ui="{ size: { lg: 'p-1 pt-1.5' } }">
                <UButton
                    icon="i-solar-cart-5-line-duotone"
                    size="xl"
                    variant="ghost"
                    color="gray"
                    :padded="false"
                    :loading="pending"
                    aria-label="cart"
                />
            </UChip>
            <template #panel>
                <div class="p-4 pb-0 max-h-[50vh] overflow-auto relative">
                    <LayoutsDefaultCartPopover
                        :items="cart.cartItems"
                        :loading="pending"
                        @update:idle="forceOpen = false"
                        @update:pending="forceOpen = true"
                    />
                </div>
            </template>
        </UPopover>
    </div>
</template>

<script lang="ts" setup>
const { data: cart, pending, get, refresh } = useCart();

onNuxtReady(() => {
    refresh();
});

const forceOpen = ref(false);

const open = computed({
    get() {
        if (forceOpen.value) return true;
        return undefined;
    },
    set(v: boolean) {
        if (forceOpen.value) return true;
        return v ?? false;
    },
});

const cartCount = computed(() => {
    if (cart.cartItems?.length) return cart.cartItems.length;
    return 0;
});
</script>

<style></style>
